export default __webpack_public_path__ + "static/media/logo.6a070e4f.svg";